import type { CellContext } from "@tanstack/react-table";

import { TypographyP } from "@/components/ui/typography";

export enum DatevExportType {
  BUCHUNGSDATENSERVICE_BOOKINGS = "buchungsdatenservice-bookings",
  BUCHUNGSDATENSERVICE_SUPPLIERS = "buchungsdatenservice-suppliers",
}

export const ExportTypeCell = ({ cell }: CellContext<any, unknown>) => {
  const { row } = cell;

  const exportType = row.original.exportType as DatevExportType;

  const typeMapper = {
    [DatevExportType.BUCHUNGSDATENSERVICE_BOOKINGS]:
      "Buchungsdatenservice - Buchungen",
    [DatevExportType.BUCHUNGSDATENSERVICE_SUPPLIERS]:
      "Buchungsdatenservice - Kreditoren",
  };

  if (!typeMapper[exportType]) {
    return null;
  }

  return <TypographyP>{typeMapper[exportType]}</TypographyP>;
};
